<template>
  <div id="app">
    <mobile v-if="isMobile"></mobile>
    <desktop v-else></desktop>
  </div>
</template>

<script>
  import Mobile from '@/components/home/mobile'
  import Desktop from '@/components/home/desktop'

  export default {
    name: 'App',

    data() {
      return {
        isMobile: false
      }
    },

    created() {
      this.checkIsMobile()
      window.addEventListener('resize', this.checkIsMobile, false)
      this.$apm.addLabels({ group: 'global-miui-fe' })
    },

    methods: {
      checkIsMobile() {
        this.isMobile = document.documentElement.clientWidth < 1024
      }
    },

    components: {
      Mobile,
      Desktop
    }
  }
</script>

<style>
  @import './styles/reset.css';
</style>
